import TiptapTable from '@tiptap/extension-table'

export const Table = TiptapTable.configure({ resizable: true, lastColumnResizable: false, HTMLAttributes: { class: 'tiptap-table' } })

export default Table
